/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateAdminUserDto } from '../../models/create-admin-user-dto';
import { UserResponseAdminAdminDto } from '../../models/user-response-admin-admin-dto';

export interface AdminUsersControllerCreateAdminUser$Params {
      body: CreateAdminUserDto
}

export function adminUsersControllerCreateAdminUser(http: HttpClient, rootUrl: string, params: AdminUsersControllerCreateAdminUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserResponseAdminAdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminUsersControllerCreateAdminUser.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserResponseAdminAdminDto>;
    })
  );
}

adminUsersControllerCreateAdminUser.PATH = '/admin/users';
